import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-editable-mode-toggle',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, MatButtonToggleModule],
  templateUrl: './editable-mode-toggle.component.html',
  styleUrl: './editable-mode-toggle.component.scss'
})
export class EditableModeToggleComponent {
  @Input() section: FormGroup;

  get config(): FormGroup {
    return this.section.get('config') as FormGroup;
  }

  getEditableMode(): string {
    const editableControl = this.config.get('editable');
    const editRequiredControl = this.config.get('editRequired');

    const editable = editableControl?.value ?? false;
    const editRequired = editRequiredControl?.value ?? false;

    if (editRequired && editable) {
      return 'edit-required';
    } else if (editable && !editRequired) {
      return 'editable';
    } else {
      return 'not-editable';
    }
  }

  onEditableModeChange(event: MatButtonToggleChange): void {
    const editableControl = this.config.get('editable');
    const editRequiredControl = this.config.get('editRequired');

    switch (event.value) {
      case 'not-editable':
        editableControl?.setValue(false);
        editRequiredControl?.setValue(false);
        break;
      case 'editable':
        editableControl?.setValue(true);
        editRequiredControl?.setValue(false);
        break;
      case 'edit-required':
        editableControl?.setValue(true);
        editRequiredControl?.setValue(true);
        break;
    }

    this.section.markAsDirty();
  }
}
